<template>
  <div class="app">
    <div class="index">
      <span class="top" />
      <span class="index-logo" />

      <span class="index-ren2" />
      <span class="index-ren3" />
      <span class="index-ren1" />

      <span class="index-guo" />
      <span class="index-mian" />

      <span class="index-slogan" />
      <span class="index-slogan2" />

      <p class="index-login-after">
        <span class="uname" /> 账号: {{ loginUserName }}&nbsp; {{ roleName }} <a class="loginout" @click="actionsClick('showTcc')">注销账号</a>
      </p>
      <p class="index-login-before">
        当前是游客状态，赶紧 <a class="lgBtn">登录</a> 参与活动吧!
      </p>
    </div>
    <div class="yaoyaole">
      <p class="yaoyaole-counts">
        每次消耗3积分 当前积分：<span
          class="yaoyaole-integral-current"
        >{{ score }}</span>
      </p>
      <span class="yaoyaole-shake" />
      <span class="yaoyaole-hb" />
      <a class="button yaoyiyao-btn" @click="yaoyiyaoBtn()">摇一摇</a>
      <span class="yaoyaole-jp" />
      <a class="button yaoyaole-btn" @click="yaoyaoleBtn()">获奖记录</a>
    </div>
    <div class="get-integral">
      <p class="get-integral-time">任务每日&nbsp;<font color="#f7ef20">00:00</font>&nbsp;重置 当前积分：<font color="#f7ef20">{{ score }}</font></p>
      <span class="get-integral-clomn">
        每日页面<br>
        签到<br>
        <font>积分+2</font><br>
        <a id="getLq" class="button get-integral-btn" @click="getLqClick()">领取</a>
      </span>

      <span class="get-integral-clomn">
        每日邀请1位<br>
        好友参与活动<br>
        <font>积分+3</font><br>
        <a id="toOver" class="button get-integral-btn" @click="toOverClick()">去完成</a>
      </span>

      <span class="get-integral-clomn">
        每日游戏内<br>
        活跃度满值<br>
        <font>积分+5</font><br>
        <a id="toLq" class="button get-integral-btn" @click="toLqClick()">领取</a>
      </span>
      <br>
      <!-- (邀请成功人数: <span class="get-integral-total">{{ yqCounts }}</span>/3) -->
    </div>
    <div class="lucky-warrior">
      <div class="lucky-warrior-wrapper">
        <VnodeLb :luky-person.sync="lukyPerson" :config="config">
          <template v-slot="vData">
            <li v-for="item in vData.vDota" :key="item.id" class="iztVnode-item" :style="{ height: vData.config.itemHeight + 'px',lineHeight: vData.config.itemHeight + 'px' }">
              <span class="iztVnode-clomn1">{{ item.who }}</span>
              <span class="iztVnode-clomn2">获得</span>
              <span class="iztVnode-clomn3">{{ item.name }}</span>
            </li>
          </template>
        </VnodeLb>

      </div>
    </div>

    <Rule>
      <template v-slot="slotProps">
        <a href="" class="button rule-btn ios">{{ slotProps.btns.btn1 }}</a>
        <a href="" class="button rule-btn android">{{ slotProps.btns.btn1 }}</a>
        <a href="/index.shtml" class="button rule-btn">{{ slotProps.btns.btn2 }}</a>
      </template>

    </Rule>
    <Popups ref="Popups" :recording-list="recordingList" :zone-id="zoneId" :role-id="roleId" :prize-name="prizeName" @roleHandler="roleHandler" />
    <Loading v-show="show" />
    <div v-show="hpbgShow" class="hp-bg" />
  </div>
</template>
<script>
// import { mapState } from 'vuex';
// import BScroll from 'better-scroll';
import apiFetch from './api/api';
import Mixins from './api/Mixins';
import mouteMixins from './api/mouteMixins';
import Loading from './components/Loading.vue';
import Rule from './components/Rule.vue';
import Popups from './components/Popups.vue';

import '@babel/polyfill';
export default {
  components: {
    Rule,
    Popups,
    Loading
  },
  mixins: [
    Mixins,
    mouteMixins
  ],
  data() {
    return {
      show: false,
      hpbgShow: false,
      roleName: '', // 角色名称
      zoneId: '', // 服务器ID
      roleId: '', // 角色ID
      prizeName: '超值', // 中奖弹窗的奖品名称
      startTime: 0, // 是否到抽奖时间
      startTimeMsg: '', // 提示文字
      StartTimes: new Date('2020/05/01 00:00:00'),
      EndTime: new Date('2020/05/06 00:00:00'),

      config: {
        itemHeight: 40, // 滚动行高度 默认50
        sCro: 1, // 0:禁止自动上下滚动 默认为:1
        startsCro: 0, // 控制什么时候开始 1
        overFlow: 0 // 0不允许手指或者鼠标滑动  默认1
      },

      // 获奖记录
      recordingList: [
        {
          id: '2', name: 'LSIJEGKILENKW', type: '2', time: '2020-05-05'
        }
      ]
    };
  },
  computed: {

    // ...mapState({

    // })
  },
  mounted() {
    const _this = this;
    apiFetch.cjLog(_this);

    document.querySelector('.yaoyaole-shake').addEventListener('animationend', () => {
      document.querySelector('.yaoyaole-shake').className = document.querySelector('.yaoyaole-shake').className.replace(' on', '');
      apiFetch.Cj(_this);
    }, false);

document.querySelector('.yaoyaole-shake').addEventListener('webkitAnimationEnd', () => {
      document.querySelector('.yaoyaole-shake').className = document.querySelector('.yaoyaole-shake').className.replace(' on', '');
      apiFetch.Cj(_this);
    }, false);

    // gLogin,
    requirejs(['jquery', 'share/share', 'downloadway/main', 'login/index'], function($, ztshare, Download, gLogin) {
      // 滚动
      let yaoyaole = document.querySelector('.yaoyaole');
      let getintegral = document.querySelector('.get-integral');
      let luckywarrior = document.querySelector('.lucky-warrior');
      let rule = document.querySelector('.rule');

      function hasClass(name) {
        return name.className.indexOf('on') === -1;
      }
      
      document.addEventListener('scroll', function() {
        let top = document.documentElement.scrollTop || document.body.scrollTop;
        if (top > 340 && hasClass(yaoyaole)) {
          yaoyaole.className += ' on';
        }
        if (top > 850 && hasClass(getintegral)) {
          getintegral.className += ' on';
        }
        if (top > 1250 && hasClass(luckywarrior)) {
          luckywarrior.className += ' on';
          _this.config.startsCro = 1;
        }
        if (top > 1400 && hasClass(rule)) {
          rule.className += ' on';
        }
      })

      document.querySelector('.hp-bg').addEventListener('touchmove', () => {
        return false;
      }, false);

      function acrossOrVertical() {
        if (window.orientation === 180 || window.orientation === 0) {
          _this.hpbgShow = false;
        }
        if (window.orientation === 90 || window.orientation === -90) {
          _this.hpbgShow = true;
        }
      }
      acrossOrVertical();
      window.addEventListener('onorientationchange' in window ? 'orientationchange' : 'resize', acrossOrVertical, false);

      // 关闭弹窗
      $('.tcc-close,.tcc-button-ok').on('click', function() {
        $('.popups-tcc.on').length === 1 && $('.popups-cover').removeClass('on');
        $(this).parent().removeClass('on');
      })

      // 下载
      new Download({
        iosBtn: $('.ios'),
        androidBtn: $('.android'),
        qrcode: $('.qrcode'),
        display: 'inline-block',
        tip: '敬请期待',
        callback: function(info) {

        }
      });

      let wxtitle = '《征途2手游》五一天天乐';
      let m_inviteurl = _this.shareUrl || window.location.href;
      let wxdesc = '豪华特制周边，千元游戏好礼，五一狂欢，好礼免费送！每日完成积分小任务即可抽奖获得！';
      let wximages = require('./images/share.jpg');
      _this.runwx = new ztshare({
        dom: document.getElementById('share'),
        url: m_inviteurl,
        title: wxtitle,
        desc: wxdesc,
        images: wximages,
        phone: {
          wxapi: 'wx0fcf7f47419c8171',
          dataUrl: m_inviteurl,
          success: function() {
            // alert("分享成功");
          },
          cancel: function() {
            alert('取消分享');
          }
        }
      })

      _this.startLogin = new gLogin({
        type: 'popup',
        login_type: 27,
        fastreg: {
          game: 'zt2m',
          type: 'normal',
          onSuccess: function(info) {

          }
        },
        onInit: function(that) {
          if (~~localStorage.getItem('switch') === 1) {
            that.login();
          }
        },
        onLogin: function(result, fromeCookie, fromReg) {
          if (!!result && !!result.account) {
            _this.islogin = 1;// 改变登录状态
            localStorage.setItem('switch', 0);

            $('.index-login-after').show();
            $('.index-login-before').hide();
            // 切换登陆

            _this.loginUserName = result.showaccount; // 用户名字

            if (_this.GetQueryString('f')) {
              apiFetch.inVite(_this.GetQueryString('f'));
            }

            apiFetch.getIndexCfg(_this);
            apiFetch.getInfo(_this); // 用户信息
          } else {
            // 登录失败
            alert(result.msg);
          }
        },
        onLogout: function(result) {
          if (!!result && !!result.status && result.status > 0) {
            // 注销成功
            location.reload();
            $('.index-login-before').show();
            $('.index-login-after').hide();
          } else {
            // 注销失败
            alert(result.msg);
          }
        }
      });

      _this.$nextTick(function() {
        $('.index').addClass('on');
        setTimeout(() => {
          document.getElementById('Loadding').style.display = 'none';
        }, 300);
      })

      // 登录 注销
      $('.lgBtn').click(function() {
        var NowTime = new Date();

        if (NowTime < _this.StartTimes) {
          alert('活动于05月01日00点开始！敬请期待！');
          return false;
        }
        if (NowTime >= _this.EndTime) {
          alert('活动已结束！');
          return false;
        }
        _this._login();
      });
      $('.loginout').click(function() {
        localStorage.setItem('switch', 0);
        _this.startLogin.logout();
      });

      // 切换账号
      $('.switchAccount').click(function() {
        localStorage.setItem('switch', 1);
        _this.startLogin.logout();
      });
    });
  },
  methods: {
    handler(msg) {
      this.addressId = msg;
      apiFetch.getAddr(this);
    },
    roleHandler(msg) {
      this.roleName = msg;
    },
    _login() {
      if (this.islogin === 0) {
        this.startLogin.login();
        return false;
      }
    },
    yaoyaoleBtn() {
      // 获奖记录
      var NowTime = new Date();

      if (NowTime < this.StartTimes) {
        alert('活动于05月01日00点开始！敬请期待！');
        return false;
      }
      if (NowTime >= this.EndTime) {
        alert('活动已结束！');
        return false;
      }

      this._login();
      if (this.islogin === 0) return false;
      if (this.roleName === '') {
        this.actionsClick('showTcc', 'binding');
        return false;
      }

      apiFetch.listInfo(this);
      this.actionsClick('showTcc', 'list');
    },
    // 签到
    getLqClick() {
      var NowTime = new Date();

      if (NowTime < this.StartTimes) {
        alert('活动于05月01日00点开始！敬请期待！');
        return false;
      }
      if (NowTime >= this.EndTime) {
        alert('活动已结束！');
        return false;
      }
      this._login();
      if (this.islogin === 0) return false;
      if (this.roleName === '') {
        this.actionsClick('showTcc', 'binding');
        return false;
      }
      if (this.day_login_act === 1) return false;
      apiFetch.checKin(this);
    },
    // 每日邀请
    toOverClick() {
      var NowTime = new Date();

      if (NowTime < this.StartTimes) {
        alert('活动于05月01日00点开始！敬请期待！');
        return false;
      }
      if (NowTime >= this.EndTime) {
        alert('活动已结束！');
        return false;
      }
      this._login();
      if (this.islogin === 0) return false;
      if (this.roleName === '') {
        this.actionsClick('showTcc', 'binding'); return false;
      }

      if (this.yqCounts === 1 && this.day_invite_3 === 0) {
        apiFetch.dayInvite(this);
        return false;
      }

      if (this.yqCounts === 1 && this.day_invite_3 === 1) {
        return false;
      }
      this.actionsClick('showTcc', 'share');
    },
    // 每日活跃度
    toLqClick() {
      var NowTime = new Date();

      if (NowTime < this.StartTimes) {
        alert('活动于05月01日00点开始！敬请期待！');
        return false;
      }
      if (NowTime >= this.EndTime) {
        alert('活动已结束！');
        return false;
      }
      this._login();
      if (this.islogin === 0) return false;
      if (this.roleName === '') {
        this.actionsClick('showTcc', 'binding'); return false;
      }
      if (this.active_val_ok === 0) {
        apiFetch.dayActive(this);
      }
    },
    // 摇一摇按钮
    yaoyiyaoBtn() {
      var NowTime = new Date();

      if (NowTime < this.StartTimes) {
        alert('活动于05月01日00点开始！敬请期待！');
        return false;
      }
      if (NowTime >= this.EndTime) {
        alert('活动已结束！');
        return false;
      }
      // if (this.startTime === 0) {
      //   alert(this.startTimeMsg);
      //   return false;
      // }
      this._login();
      if (this.islogin === 0) return false;
      if (this.roleName === '') {
        this.actionsClick('showTcc', 'binding'); return false;
      }
      if (this.score >= 3) {
        document.querySelector('.yaoyaole-shake').className += ' on';
      } else {
        this.actionsClick('showTcc', 'tips2');
      }
    }

  }
};
</script>
